import '../../../assets/css/AddCatalogs.css';
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Axios from "../../../utils/axios";
import { useEffect, useState, useLayoutEffect } from "react";
import PlusIcon from '../../../components/Atomos/Icons/PlusIcon';
import DropDown from '../../../components/Atomos/DropDown/Dropdown';
import Remove from '../../../components/Atomos/Icons/Remove';
import SaveOverride from '../../../components/Catalogs/SaveOverride';
import Input from '../../../components/Atomos/Inputs/Input';
import SwitchToogle from '../../../components/Atomos/Switch-Toogle/Switch';
import NewButton from '../../../components/Atomos/Buttons/newButton';
import ButtonsCrud from '../../../components/Catalogs/ButtonsCrud';
import DDMultiple, { Option } from '../../../components/Atomos/DropDown/DDMultiple';
import CatalogSubTitle from '../../../components/Moleculas/Catalog Text/CatalogSubTitle';
import PracticeIndustriesMapping from '../../../components/MappingAOP/AOPMapping';
import { IAreaOfPractice } from '../../../interfaces/models/IAreaOfPractice';
import Modal from '../../../components/Atomos/Modals/Modal';
import Rewind from '../../../components/Atomos/Icons/Rewind';
import CancelClear from '../../../components/Atomos/Icons/CancelClear';
import { UseFirmList, firmType } from '../../../hooks/Catalogs/useFirm';
import { UsePracticeIndustryList } from '../../../hooks/Catalogs/usePracticeIndustry';
import IFirm from '../../../interfaces/models/IFirm';
import { getOfficeByFirm } from '../../../Services/Office';
import { getCurrentTimestamp, getNameById } from '../../../utils/functions';
import { IPracticeIndustry } from '../../../interfaces/models/IPracticeIndustry';
import { countPersonsByOffices } from '../../../Services/Person';

const axios = new Axios();
interface iCatalogProps {
  mode: "add" | "edit";
  returnPage?: string;
}

interface IErrorState {
  nameAlreadyExists: boolean;
  nameRequired: boolean;
  firmsRequired: boolean;
  officesRequired: boolean;
  firmsErrorMessage: string;
  officesErrorMessage: string;
  lenErr?: boolean;
  practiceIndustriesRequired?: boolean;
}

const initialErrorState: IErrorState = {
  nameAlreadyExists: false,
  nameRequired: false,
  firmsRequired: false,
  officesRequired: false,
  firmsErrorMessage: "",
  officesErrorMessage: "",
  lenErr: false,
  practiceIndustriesRequired: false,
};

function transformFirmsData(firmsData: any) {
  return firmsData?.map((firm: any) => ({
    id: firm.id,
    name: firm.name,
    title: firm.firmName,
    disable: false
  }));
}

interface FirmOfficePair {
  firm: Option | null;
  offices: Option[];
  formattedOffices?: Option[];
  error: boolean;
}

const AddAOP: React.FC<iCatalogProps> = (props) => {
  const { state } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode } = props;
  const isEditMode = props.mode === "edit";
  const [isMapped, setIsMapped] = useState(false);
  const [isIgnored, setIsIgnored] = useState(false);
  const [isTargeted, setIsTargeted] = useState(false);
  const [errorState, setErrorState] = useState<IErrorState>(initialErrorState);
  const [formattedFirms, setFormattedFirms] = useState<any[]>([])
  const [showSaveOverride, setShowSaveOverride] = useState(false);
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState('')
  const { id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isModified, setIsModified] = useState(true);
  const [firmsOfficesPairs, setFirmsOfficesPairs] = useState<FirmOfficePair[]>([{
    firm: null,
    offices: [],
    error: false,
  }]);
  const [selectedFirmIds, setSelectedFirmIds] = useState<(string | undefined) []>([]);
  const [officeData, setOfficeData] = useState<any[]>([]);

  const { firmData } = UseFirmList();
  const { practiceIndustryData } = UsePracticeIndustryList();
  const [currentPracticeIndustries, setCurrentPracticeIndustries] = useState<any[]>([]);

  const attemptSaveOrUpdate = async (action: string) => {
    await updateAop()
  };

  const handleAddFirmOfficePair = () => {
    setFirmsOfficesPairs([...firmsOfficesPairs, { firm: {} as Option, offices: [], error: false }]);
    setErrorState(initialErrorState)
    setShowSaveOverride(false)
  };

  const handleRemoveFirmOfficePair = (index: number) => {
    setFirmsOfficesPairs(firmsOfficesPairs.filter((_, i) => i !== index));
    setErrorState(initialErrorState)
    setShowSaveOverride(false)
  };

  const handleFirmsChange = async (selectedItem: Option, index: number) => {
    if (!selectedItem.id) {
      return;
    }

    const selectionPropItem: Option = {
      id: selectedItem.id,
      name: selectedItem.name,
    };

    const newPairs = [...firmsOfficesPairs];
    newPairs[index].firm = selectionPropItem;

    setFirmsOfficesPairs(newPairs);
    setErrorState(initialErrorState);
    fetchOffices(selectedItem.id, index);
  };

  const fetchOffices = async (firmId: string, index: number) => {
    try {
      const offices = (await getOfficeByFirm(firmId)).map((o: any) => ({ id: o.id, name: o.name }));
      const _officeData = [...officeData];
      _officeData[index] = offices;
  
      setOfficeData(_officeData);
    } catch (error) {
      console.error(error);
    }
  };

  const handleOfficesChange = (selectedItems: Option[], index: number) => {
    const newPairs = [...firmsOfficesPairs];
    newPairs[index].offices = selectedItems;
    setFirmsOfficesPairs(newPairs);
    setErrorState(initialErrorState);
  };


  useEffect(() => {
    if (!firmData.length) {
      return
    }

    const filteredFirms = firmData.filter((firm: IFirm) => !selectedFirmIds.includes(firm.id));
    const transformedFirms = transformFirmsData(filteredFirms);
    setFormattedFirms(transformedFirms)
  }, [firmData, firmsOfficesPairs]);

  useEffect(() => {
    setSelectedFirmIds(firmsOfficesPairs.map(f => f.firm?.id))
  },[firmsOfficesPairs])

  useEffect(() => {
  }, [firmsOfficesPairs]);

  const updateAop = async () => {
    try {
      const firms = firmsOfficesPairs.map(f => ({
        id: f.firm?.id,
        office: f.offices?.map(o => o.id) 
      }))
      const practiceIndustryIds = currentPracticeIndustries
        .filter(cp => cp.isChecked)
        .map(cp => cp.id);
      const firmNames = firms.map(f => getNameById(f.id, firmData))?.join(', ');
      const practiceIndustryNames = practiceIndustryIds.map(p => getNameById(p, practiceIndustryData))?.join(', ');
      const professionals = await countProfessionals()
      const newAOP: IAreaOfPractice = {
        ...state,
        name: inputValue?.trim() !== '' ? inputValue : state?.name,
        isIgnored: isIgnored,
        firms,
        firmNames,
        practiceIndustries: practiceIndustryIds,
        practiceIndustryNames,
        professionals,
        createdDate: state?.createdDate ?? getCurrentTimestamp()
      }
      mode === 'edit' 
        ? await axios.Put('/areaOfPractice', newAOP) 
        : await axios.Post('/areaOfPractice', newAOP)
        navigate(-1)
    } catch (error) {
      console.error(error)
    }
  }

  const countProfessionals = async () => {
    try {
      const officeIds = firmsOfficesPairs
        .map(f => f.offices?.map(o => o.id))
  
      if (officeIds.length === 0) {
        return 0;
      }
  
      const flattenedOfficeIds = officeIds.flat().filter((id): id is string => id !== undefined);
      const [professionalsNumber] = await countPersonsByOffices(flattenedOfficeIds);
      return professionalsNumber
    } catch (error) {
      console.error(error);
      return 0;
    }
  };
  

  useEffect(() => {
    setErrorState(initialErrorState);
    setShowSaveOverride(false)
  }, [practiceIndustryData, isIgnored]);

  useLayoutEffect(() => {
    loadOfficesForFirms();
    loadCurrentPI()
  }, [state]);
  
  const loadOfficesForFirms = async () => {
    if (!state?.firms) {
      return;
    }

    const offices = await Promise.all(
      state.firms.map(async (firm: any) => {
        return (await getOfficeByFirm(firm.id)).map((o: any) => ({ id: o.id, name: o.name }));
      })
    );
    setOfficeData(offices);

    const _firmsOfficesPairs = state.firms?.map((firm: any, index: any) => {
      return {
      firm: {id: firm.id, name: getNameById(firm.id, firmData).join()},
      error: false,
      offices: firm.office?.map((o: any) => offices[index].find((office: any) => office.id === o),
    )}})

    if (_firmsOfficesPairs.length) {
      setFirmsOfficesPairs(_firmsOfficesPairs);
    }
  };

  const loadCurrentPI = async () => {
    if (state?.practiceIndustries?.length) {
      const updatedIndustries = practiceIndustryData.map(pi => {
        if (state.practiceIndustries.includes(pi.id)) {
          return { ...pi, isChecked: true };
        }
        return { ...pi, isChecked: false }
      });
      setCurrentPracticeIndustries(updatedIndustries)
    } else {
      const blankPI: IPracticeIndustry[] = practiceIndustryData.map(p => ({
        id: p.id,
        name: p.name,
        icon: p.icon,
        createdAt: p.createdAt,
      }))
      setCurrentPracticeIndustries(blankPI)
    }
  }
  
  const handleCheckboxChange = (industryId: string) => {
    const updatedIndustries = currentPracticeIndustries.map(industry => {
      if (industry.id === industryId) {
        return { ...industry, isChecked: !industry.isChecked };
      }
      return industry;
    });
    setCurrentPracticeIndustries(updatedIndustries);
  };

  const handleMergeNames = async (confirm?: boolean) => {
  };

  const inputOnchange = (e: any) => {
    setInputValue(e.target.value);
    const nameError = inputValue?.trim() === '';
    setErrorState(prevState => ({
      ...prevState,
      nameRequired: nameError,
      nameAlreadyExists: false
    }));
    setIsModified(true);
    setErrorState(initialErrorState);
  };

  const isButtonDisabled = () => {
    return !isModified || Object.values(errorState)?.some(error => error);
  };

  const handleCloseSaveOverride = () => {
    setErrorState({ ...initialErrorState })
    setShowSaveOverride(false);
  };

  const RemoveIcon = () => {
    return (
      <div className='w-[1.25rem] h-[1.25rem]'>
        <Remove />
      </div>
    )
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const MergeIcon = () => (
    <div className=''>
      <Rewind />
    </div>
  )

  const CancelIcon = () => (
    <div className=''>
      <CancelClear />
    </div>
  )

  const handleDelete = async (id: string) => {
    try {
      const deleteAopResponse = await axios.Delete(`/AreaOfPractice`, id);
      if (deleteAopResponse.status === 200) {
        navigate(props.returnPage ? props.returnPage : '/Catalogs/AreaOfPractice');
      } else {
        console.error('Error al eliminar el AOP:', deleteAopResponse.data);
      }
    } catch (error) {
      console.error('Error durante la eliminación:', error);
    }
  };

  return (
    <>
      <main className={`${showSaveOverride && 'pt-7'}`}>
        {showSaveOverride && (
          <SaveOverride
            fields={errorFields}
            open={showSaveOverride}
            close={handleCloseSaveOverride}
            handleButtonClick={attemptSaveOrUpdate}
          />
        )}
        {(isModalOpen) &&
          <>
            <div>
              <Modal isModalOpen={isModalOpen} toggleModal={handleCloseModal} title='Merge AOP' className='min-w-[18.75rem] md:min-w-[34.5rem] py-5 px-4 md:px-7 md:py-7 lg:px-10 lg:py-10'
                children={
                  <>
                    <span className='text-left text-[#474F56] w-full flex mb-8  text-base leading-6 lg:text-[1.125rem] font-normal lg:leading-6'>Do you want to merge this mapping with the existent data?</span>
                    <div className='flex flex-col md:flex-row justify-around gap-5'>
                      <NewButton className='!min-w-[13.125rem]' onClick={() => setIsModalOpen(false)} text='CANCEL' color='neutral' style='outlined' content='textIcon' icon={<CancelIcon />} />
                      <NewButton onClick={handleMergeNames} text='Merge AOP' color='primary' content='textIcon' icon={<MergeIcon />} />
                    </div>
                  </>
                } />
            </div>
          </>
        }
        <article className='articleSection'>
          {props.mode === 'add' &&
            <>
              <section className="formsectionNTitle">
                <CatalogSubTitle className="text-accent-Default-dark" title="AOP Information" />
              </section>
              <div className='flex flex-col items-start gap-5 self-stretch lg:flex-row'>
                <div className='flex items-start gap-5 self-stretch w-full'>
                  <Input
                    isWfull={true}
                    value={inputValue}
                    onChange={inputOnchange}
                    name="Name"
                    title="Name"
                    required={true}
                    error={errorState.nameRequired || errorState.nameAlreadyExists}
                    errorMsj={
                      errorState.nameRequired ? "Name is required." : errorState.nameAlreadyExists ? "This value is already registered in the DB. Please input a different/new one." :
                        ""}
                  />
                </div>
                <div className='flex justify-center items-start gap-5 self-stretch md:justify-start'>
                  <div className='flex flex-col items-center justify-center gap-[.625rem]'>
                    <label className='text-base leading-[1.125rem] text-center text-[#474F56]'>Is Mapped?</label>
                    <SwitchToogle seter={() => setIsMapped(!isMapped)} checked={isMapped} small disabled={!isEditMode} centered />
                  </div>
                  <div className='flex flex-col items-center justify-center gap-[.625rem]'>
                    <label className='text-base leading-[1.125rem] text-center text-[#474F56]'>Is Ignored?</label>
                    <SwitchToogle seter={() => setIsIgnored(!isIgnored)} checked={isIgnored} small disabled={!isEditMode} centered />
                  </div>
                  <div className='flex flex-col items-center justify-center gap-[.625rem]'>
                    <label className='text-base leading-[1.125rem] text-center text-[#474F56]'>Is Targeted?</label>
                    <SwitchToogle seter={() => setIsTargeted(!isTargeted)} checked={isTargeted} small disabled={!isEditMode} centered />
                  </div>
                </div>
              </div>
            </>
          }
          <div className='flex flex-col items-start gap-6 self-stretch'>
            <section className="formsectionNTitle">
              <CatalogSubTitle className="text-accent-Default-dark" title="Catalog List Relationships" />
            </section>
            <div className='flex flex-col items-start gap-5 self-stretch'>
              {
                firmsOfficesPairs?.map((pair, index) => (
                  <div className='w-full flex flex-col gap-5 md:flex-row' key={index}>
                    <DropDown
                      title="Firms"
                      required={true}
                      getid={true}
                      data={formattedFirms}
                      selectedObjst={pair.firm ? pair.firm.name : ''}
                      seter={(selectedItem) => handleFirmsChange(selectedItem, index)}
                      error={errorState.firmsRequired}
                      errormsj={errorState.firmsRequired ? errorState.firmsErrorMessage : undefined}
                    />
                    <div className="w-full">
                      <DDMultiple
                        required
                        title="Offices"
                        objects={officeData[index]}
                        selectedObjst={pair.offices}
                        seter={(selectedItem: any) => handleOfficesChange(selectedItem, index)}
                        error={errorState.officesRequired}
                        errorMessage={errorState.officesRequired ? errorState.officesErrorMessage : undefined}
                      />
                    </div>
                    <div className={`w-full h-max ${errorState.firmsRequired || errorState.officesRequired ? 'my-auto' : ''} md:mt-auto !max-h-[3rem] md:h-[3rem] lg:max-w-[11rem] md:max-w-[8.5rem]`}>
                      <NewButton
                        onClick={() => handleRemoveFirmOfficePair(index)}
                        text='REMOVE'
                        className=''
                        color='delete'
                        size='medium'
                        style='outlined'
                        content='textIcon'
                        icon={<RemoveIcon />}
                      />
                    </div>
                  </div>
                ))
              }
              <div className="w-full lg:max-w-[10rem] md:max-w-[8.5rem]">
                <NewButton onClick={handleAddFirmOfficePair} color='accent' size='medium' style='filled' text='ADD FIRM' content='textIcon' icon={<PlusIcon />} />
              </div>
            </div>
          </div>
          <section className="formsectionNTitle">
            <div className='flex flex-col gap-[.625rem]'>
              <CatalogSubTitle className="text-accent-Default-dark" title="Areas Of Practice Mapping" />
              {errorState.practiceIndustriesRequired ? <span className={`flex flex-wrap items-center text-sm font-medium text-feedback-error`}>Map or Ignore AOP</span> : null}
            </div>
          </section>
          <div className='flex flex-col w-full gap-5 md:flex-row'>
            <div className='flex gap-[.625rem] items-center self-stretch md:flex-col md:items-center md:w-max'>
              <label className='text-[#474F56] whitespace-nowrap text-base leading-[1.125rem] lg:text-[1.125rem] lg:leading-[1.125rem] roboto_font'>Ignore AOP</label>
              <SwitchToogle checked={isIgnored} seter={() => setIsIgnored(!isIgnored)} small={true} centered />
            </div>
            {isEditMode && (
              <div className='flex items-start gap-5 self-stretch w-full'>
                <Input
                  isWfull={true}
                  value={inputValue}
                  onChange={inputOnchange}
                  name="Name"
                  title="Rename AOP"
                  required={false}
                  error={errorState.nameRequired || errorState.nameAlreadyExists}
                  errorMsj={
                    errorState.nameRequired ? "Name is required." : errorState.nameAlreadyExists ? "This value is already registered in the DB. Please input a different/new one." : ""}
                />
              </div>  
            )}
          </div>
          <PracticeIndustriesMapping practiceIndustries={currentPracticeIndustries} onIndustryChange={handleCheckboxChange} />
          <div className='flex gap-[.625rem] justify-end'>
          </div>
          <ButtonsCrud 
            Catalog="AreaOfPractice" 
            mode={props.mode} 
            disabled={isButtonDisabled()} 
            id={id ? id : ''} 
            actionButton={attemptSaveOrUpdate} 
            onDelete={handleDelete} 
          />
        </article>
      </main>
    </>
  );
}

export default AddAOP;
